import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export type GuidelinesCharacterLimitModalProps = {
  open: boolean;
  onDiscard: () => void;
  onContinueEditing: () => void;
};

export const GuidelinesCharacterLimitModal = ({
  open,
  onDiscard,
  onContinueEditing,
}: GuidelinesCharacterLimitModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onContinueEditing()}>
      <DialogContent className="gap-6 sm:max-w-md">
        <DialogHeader className="items-start text-left">
          <DialogTitle>{t('ai_agents.knowledge.character_limit_modal.title')}</DialogTitle>
          <DialogDescription>
            {t('ai_agents.knowledge.character_limit_modal.description')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:flex-row sm:justify-end sm:space-x-2">
          <Button variant="ghost-neutral" onClick={onDiscard}>
            {t('ai_agents.knowledge.character_limit_modal.secondary_action')}
          </Button>
          <Button onClick={onContinueEditing}>
            {t('ai_agents.knowledge.character_limit_modal.primary_action')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
